import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import OrderoperateList from '../entities/order-operate'


interface OrderOperateState extends ListState<OrderoperateList> {
}

class OrderOperate extends ListModule<OrderOperateState, any, OrderoperateList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<OrderoperateList>(),
        loading: false,
        updateOrdeData: null,
        ids: [],
        BaseSkuNums : 0,
        ordertype: 0,
        site:0
    }
    actions = {
        async getAll(context: ActionContext<OrderOperateState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/OrderOperate/GetList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<OrderoperateList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
    };
    mutations = {
        setCurrentPage(state: OrderOperateState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: OrderOperateState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const orderOperate = new OrderOperate();
export default orderOperate;